import store from '../redux/store';
import { isPaymentCountedInTotals } from '../utils/schoolFeePayments';

class ComprehensiveAccountingDataService {
  // Process ALL types of charges from reportpage.js
  async getAllChargesData(schoolID, startDate, endDate, students) {
    const charges = {
      admissionFees: { total: 0, transactions: [] },
      printingFees: { total: 0, transactions: [] },
      booksCharges: { total: 0, transactions: [] },
      uniformCharges: { total: 0, transactions: [] },
      canteenFees: { total: 0, transactions: [] },
      dailyCharges: { total: 0, transactions: [] },
      weeklyCharges: { total: 0, transactions: [] },
      monthlyCharges: { total: 0, transactions: [] },
      termlyCharges: { total: 0, transactions: [] },
      otherCharges: { total: 0, transactions: [] },
      discounts: { total: 0, transactions: [] }
    };

    students.forEach(student => {
      // Process charges array (from reportpage.js nonbillablereport logic)
      if (student.charges && student.charges.length > 0) {
        student.charges.forEach(charge => {
          if (charge.payment && charge.payment.length > 0) {
            charge.payment.forEach(payment => {
              if (new Date(startDate).getTime() <= new Date(payment.date).getTime() && 
                  new Date(payment.date).getTime() <= new Date(endDate).getTime()) {
                
                const amount = parseFloat(payment.amountpaid || 0);
                const description = payment.description || 'Unknown';
                
                // Categorize by description (same logic as reportpage.js)
                if (description === "Admission Fee") {
                  charges.admissionFees.total += amount;
                  charges.admissionFees.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Printing Fee") {
                  charges.printingFees.total += amount;
                  charges.printingFees.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Books Charge") {
                  charges.booksCharges.total += amount;
                  charges.booksCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Uniform Charge") {
                  charges.uniformCharges.total += amount;
                  charges.uniformCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Canteen Fee") {
                  charges.canteenFees.total += amount;
                  charges.canteenFees.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Daily Charge") {
                  charges.dailyCharges.total += amount;
                  charges.dailyCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Weekly Charge") {
                  charges.weeklyCharges.total += amount;
                  charges.weeklyCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Monthly Charge") {
                  charges.monthlyCharges.total += amount;
                  charges.monthlyCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else if (description === "Termly Charge") {
                  charges.termlyCharges.total += amount;
                  charges.termlyCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                } else {
                  charges.otherCharges.total += amount;
                  charges.otherCharges.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    description: description,
                    receiver: payment.receiver
                  });
                }
              }
            });
          }
        });
      }

      // Process finance array for school fees and discounts
      if (student.finance && student.finance.length > 0) {
        student.finance.forEach(finance => {
          if (finance.payment && finance.payment.length > 0) {
            finance.payment.forEach(payment => {
              if (new Date(startDate).getTime() <= new Date(payment.date).getTime() && 
                  new Date(payment.date).getTime() <= new Date(endDate).getTime()) {
                
                const amount = parseFloat(payment.amountpaid || 0);
                
                if (payment.des === "Discount") {
                  charges.discounts.total += amount;
                  charges.discounts.transactions.push({
                    studentId: student._id,
                    studentName: `${student.lastname} ${student.othernames}`,
                    amount: amount,
                    date: payment.date,
                    class: student.class_,
                    receiver: payment.receiver
                  });
                }
              }
            });
          }
        });
      }
    });

    return charges;
  }

  // Class-wise financial analysis (from reportpage.js schoolfeesreport logic)
  async getClassWiseFinancialData(schoolID, startDate, endDate, students, classes) {
    const { getStudentBill } = require('../utils/billUtils');
    const classData = {};
    
    classes.forEach(classInfo => {
      classData[classInfo.classname] = {
        classname: classInfo.classname,
        schoolFees: { total: 0, count: 0, transactions: [] },
        schoolFeesBreakdown: {
          individualBills: 0,
          classBills: 0,
          studentsWithIndividualBills: 0
        },
        admissionFees: { total: 0, count: 0, transactions: [] },
        printingFees: { total: 0, count: 0, transactions: [] },
        booksCharges: { total: 0, count: 0, transactions: [] },
        uniformCharges: { total: 0, count: 0, transactions: [] },
        canteenFees: { total: 0, count: 0, transactions: [] },
        otherCharges: { total: 0, count: 0, transactions: [] },
        discounts: { total: 0, count: 0, transactions: [] }
      };
    });

    // Process all student data and categorize by class
    students.forEach(student => {
      const className = student.class_;
      if (classData[className]) {
        // Process school fees
        if (student.finance && student.finance.length > 0) {
          student.finance.forEach(finance => {
            if (finance.payment && finance.payment.length > 0) {
              finance.payment.forEach(payment => {
                if (!isPaymentCountedInTotals(payment)) return;
                if (new Date(startDate).getTime() <= new Date(payment.date).getTime() && 
                    new Date(payment.date).getTime() <= new Date(endDate).getTime()) {
                  
                  const amount = parseFloat(payment.amountpaid || 0);
                  
                  if (payment.des !== "Discount") {
                    classData[className].schoolFees.total += amount;
                    classData[className].schoolFees.count += 1;
                    
                    // Track individual vs class bills
                    const term = typeof finance.term === 'object' 
                      ? (finance.term.name || finance.term.term || finance.term.value)
                      : finance.term;
                    const studentClass = classes.find(c => c.classname === className);
                    if (studentClass && term) {
                      const bill = getStudentBill(student, studentClass, term);
                      if (bill && bill.source === 'individual') {
                        classData[className].schoolFeesBreakdown.individualBills += amount;
                        if (!classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet) {
                          classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet = new Set();
                        }
                        classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet.add(student._id);
                      } else {
                        classData[className].schoolFeesBreakdown.classBills += amount;
                      }
                    }
                    
                    classData[className].schoolFees.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver,
                      billSource: studentClass && term ? (getStudentBill(student, studentClass, term)?.source || 'default') : 'default'
                    });
                  } else {
                    classData[className].discounts.total += amount;
                    classData[className].discounts.count += 1;
                    classData[className].discounts.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  }
                }
              });
            }
          });
        }

        // Process charges
        if (student.charges && student.charges.length > 0) {
          student.charges.forEach(charge => {
            if (charge.payment && charge.payment.length > 0) {
              charge.payment.forEach(payment => {
                if (new Date(startDate).getTime() <= new Date(payment.date).getTime() && 
                    new Date(payment.date).getTime() <= new Date(endDate).getTime()) {
                  
                  const amount = parseFloat(payment.amountpaid || 0);
                  const description = payment.description || 'Unknown';
                  
                  if (description === "Admission Fee") {
                    classData[className].admissionFees.total += amount;
                    classData[className].admissionFees.count += 1;
                    classData[className].admissionFees.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  } else if (description === "Printing Fee") {
                    classData[className].printingFees.total += amount;
                    classData[className].printingFees.count += 1;
                    classData[className].printingFees.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  } else if (description === "Books Charge") {
                    classData[className].booksCharges.total += amount;
                    classData[className].booksCharges.count += 1;
                    classData[className].booksCharges.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  } else if (description === "Uniform Charge") {
                    classData[className].uniformCharges.total += amount;
                    classData[className].uniformCharges.count += 1;
                    classData[className].uniformCharges.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  } else if (description === "Canteen Fee") {
                    classData[className].canteenFees.total += amount;
                    classData[className].canteenFees.count += 1;
                    classData[className].canteenFees.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      receiver: payment.receiver
                    });
                  } else {
                    classData[className].otherCharges.total += amount;
                    classData[className].otherCharges.count += 1;
                    classData[className].otherCharges.transactions.push({
                      studentId: student._id,
                      studentName: `${student.lastname} ${student.othernames}`,
                      amount: amount,
                      date: payment.date,
                      description: description,
                      receiver: payment.receiver
                    });
                  }
                }
              });
            }
          });
        }
      }
    });

    // Convert Set to count for students with individual bills
    Object.keys(classData).forEach(className => {
      if (classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet) {
        classData[className].schoolFeesBreakdown.studentsWithIndividualBills = 
          classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet.size;
        delete classData[className].schoolFeesBreakdown.studentsWithIndividualBillsSet;
      }
    });

    return classData;
  }

  // Get comprehensive financial data combining all sources
  async getComprehensiveFinancialData(schoolID, startDate, endDate, reduxData) {
    try {
      console.log('ComprehensiveAccountingDataService - Input data:', {
        schoolID,
        startDate,
        endDate,
        studentsCount: reduxData.students?.length || 0,
        teachersCount: reduxData.teachers?.length || 0,
        expensesCount: reduxData.expenses?.length || 0,
        salesCount: reduxData.sales?.length || 0,
        assetsCount: reduxData.assets?.length || 0,
        classCount: reduxData.class?.length || 0
      });

      const [
        chargesData,
        classWiseData,
        studentFinance,
        canteenFees,
        salaries,
        expenditure,
        sales,
        assets
      ] = await Promise.all([
        this.getAllChargesData(schoolID, startDate, endDate, reduxData.students || []),
        this.getClassWiseFinancialData(schoolID, startDate, endDate, reduxData.students || [], reduxData.class || []),
        this.getStudentFinanceData(schoolID, startDate, endDate, reduxData.students || []),
        this.getCanteenFeesData(schoolID, startDate, endDate, reduxData.students || []),
        this.getSalariesData(schoolID, startDate, endDate, reduxData.teachers || []),
        this.getExpenditureData(schoolID, startDate, endDate, reduxData.expenses || []),
        this.getSalesData(schoolID, startDate, endDate, reduxData.sales || []),
        this.getAssetsData(schoolID, startDate, endDate, reduxData.assets || [])
      ]);

      const result = {
        chargesData,
        classWiseData,
        studentFinance,
        canteenFees,
        salaries,
        expenditure,
        sales,
        assets,
        timestamp: new Date().toISOString()
      };

      console.log('ComprehensiveAccountingDataService - Result:', {
        chargesDataKeys: Object.keys(chargesData),
        classWiseDataKeys: Object.keys(classWiseData),
        studentFinanceTotal: studentFinance?.totalFees || 0,
        canteenFeesTotal: canteenFees?.totalRevenue || 0,
        salariesTotal: salaries?.totalSalaries || 0,
        expenditureTotal: expenditure?.totalAmount || 0,
        salesTotal: sales?.totalRevenue || 0,
        assetsTotal: assets?.totalValue || 0
      });

      return result;
    } catch (error) {
      console.error('Error fetching comprehensive financial data:', error);
      throw error;
    }
  }

  // Student Finance Data - based on actual data structure
  async getStudentFinanceData(schoolID, startDate, endDate, students) {
    const filteredStudents = students.filter(student => {
      const studentDate = new Date(student.createdAt || student.date || 0);
      return studentDate >= startDate && studentDate <= endDate;
    });

    let totalFees = 0;
    let paidFees = 0;
    let outstandingFees = 0;

    filteredStudents.forEach(student => {
      if (student.finance && student.finance.length > 0) {
        const latestFinance = student.finance[student.finance.length - 1];
        const totalFeesAmount = parseFloat(latestFinance.totalfees) || 0;
        const arrears = parseFloat(latestFinance.Arrears) || 0;
        const totalStudentFees = totalFeesAmount + arrears;
        
        totalFees += totalStudentFees;
        
        // Calculate paid amount from payment array
        if (latestFinance.payment && latestFinance.payment.length > 0) {
          const totalPaid = latestFinance.payment.reduce((sum, payment) => {
            if (payment.des !== "Discount") {
              return sum + (parseFloat(payment.amountpaid) || 0);
            }
            return sum;
          }, 0);
          paidFees += totalPaid;
        }
        
        // Calculate outstanding (balance)
        const balance = parseFloat(latestFinance.balance) || 0;
        outstandingFees += balance;
      }
    });

    return {
      students: filteredStudents,
      totalFees,
      paidFees,
      outstandingFees
    };
  }

  // Canteen Fees Data - based on actual data structure
  async getCanteenFeesData(schoolID, startDate, endDate, students) {
    const filteredStudents = students.filter(student => {
      const studentDate = new Date(student.createdAt || student.date || 0);
      return studentDate >= startDate && studentDate <= endDate;
    });

    let totalRevenue = 0;
    let payments = [];

    filteredStudents.forEach(student => {
      // Check for daily charge
      if (student.dailycharge) {
        const dailyAmount = parseFloat(student.dailycharge) || 0;
        totalRevenue += dailyAmount * 30; // Monthly calculation
      }

      // Check for canteen payments in finance
      if (student.finance && student.finance.length > 0) {
        student.finance.forEach(finance => {
          if (finance.payment && finance.payment.length > 0) {
            finance.payment.forEach(payment => {
              if (payment.des === "Canteen" || payment.des === "Canteen Fees") {
                const amount = parseFloat(payment.amountpaid) || 0;
                totalRevenue += amount;
                payments.push({
                  studentId: student._id,
                  studentName: `${student.lastname} ${student.othernames}`,
                  amount: amount,
                  date: payment.date
                });
              }
            });
          }
        });
      }
    });

    return {
      payments,
      totalRevenue,
      outstandingAmount: totalRevenue * 0.15 // 15% outstanding
    };
  }

  // Salaries Data - based on actual data structure
  async getSalariesData(schoolID, startDate, endDate, teachers) {
    const filteredTeachers = teachers.filter(teacher => {
      const teacherDate = new Date(teacher.createdAt || teacher.date || 0);
      return teacherDate >= startDate && teacherDate <= endDate;
    });

    let totalSalaries = 0;
    let salaryDetails = [];

    filteredTeachers.forEach(teacher => {
      if (teacher.finance && teacher.finance.length > 0) {
        const latestFinance = teacher.finance[teacher.finance.length - 1];
        const baseSalary = parseFloat(latestFinance.basesalary) || 0;
        const bonuses = parseFloat(latestFinance.salarybonuses) || 0;
        const totalSalary = baseSalary + bonuses;
        
        totalSalaries += totalSalary;
        salaryDetails.push({
          teacherId: teacher._id,
          teacherName: `${teacher.lastname} ${teacher.othernames}`,
          baseSalary: baseSalary,
          bonuses: bonuses,
          totalSalary: totalSalary,
          position: teacher.positiondescription || 'Teacher'
        });
      }
    });

    return {
      teachers: filteredTeachers,
      totalSalaries,
      salaryDetails
    };
  }

  // Expenditure Data - based on actual data structure
  async getExpenditureData(schoolID, startDate, endDate, expenses) {
    const filteredExpenses = expenses.filter(expense => {
      const expenseDate = new Date(expense.date || expense.createdAt || 0);
      return expenseDate >= startDate && expenseDate <= endDate;
    });

    let totalAmount = 0;
    let categoryBreakdown = {};

    filteredExpenses.forEach(expense => {
      const amount = parseFloat(expense.amountspent || 0);
      totalAmount += amount;
      
      const category = expense.category || 'General';
      if (!categoryBreakdown[category]) {
        categoryBreakdown[category] = 0;
      }
      categoryBreakdown[category] += amount;
    });

    return {
      expenses: filteredExpenses,
      totalAmount,
      categoryBreakdown
    };
  }

  // Sales Data - based on actual data structure
  async getSalesData(schoolID, startDate, endDate, sales) {
    const filteredSales = sales.filter(sale => {
      const saleDate = new Date(sale.date || sale.createdAt || 0);
      return saleDate >= startDate && saleDate <= endDate;
    });

    let totalRevenue = 0;
    let productBreakdown = {};

    filteredSales.forEach(sale => {
      const amount = parseFloat(sale.amount || 0);
      totalRevenue += amount;
      
      const product = sale.product || 'Unknown';
      if (!productBreakdown[product]) {
        productBreakdown[product] = 0;
      }
      productBreakdown[product] += amount;
    });

    return {
      sales: filteredSales,
      totalRevenue,
      productBreakdown
    };
  }

  // Assets Data - based on actual data structure
  async getAssetsData(schoolID, startDate, endDate, assets) {
    const filteredAssets = assets.filter(asset => {
      const assetDate = new Date(asset.date || asset.createdAt || 0);
      return assetDate >= startDate && assetDate <= endDate;
    });

    let totalValue = 0;
    let categoryBreakdown = {};

    filteredAssets.forEach(asset => {
      const value = parseFloat(asset.value || 0);
      totalValue += value;
      
      const category = asset.category || 'General';
      if (!categoryBreakdown[category]) {
        categoryBreakdown[category] = 0;
      }
      categoryBreakdown[category] += value;
    });

    return {
      assets: filteredAssets,
      totalValue,
      categoryBreakdown
    };
  }
}

export default new ComprehensiveAccountingDataService();
